import React from "react";

export const OpenLock = () => {
  return (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.68084 1.75533C4.03469 1.38361 4.50822 1.18055 4.99545 1.18055C5.48268 1.18055 5.95621 1.38361 6.31006 1.75533C6.66484 2.12803 6.86894 2.63947 6.86894 3.17847V3.76875L8.04949 3.76875V3.17847C8.04949 2.34462 7.73444 1.53942 7.16514 0.941358C6.59489 0.34231 5.81508 0 4.99545 0C4.17582 0 3.39601 0.34231 2.82576 0.941358C2.25646 1.53942 1.94141 2.34462 1.94141 3.17847V6.02246H0V13.6745H10.4881V6.02246H3.12196V3.17847C3.12196 2.63947 3.32606 2.12803 3.68084 1.75533ZM1.18055 7.20302V12.494H9.30756V7.20302H1.18055ZM5.24508 10.7192C5.69865 10.7192 6.06634 10.3515 6.06634 9.89792C6.06634 9.44435 5.69865 9.07666 5.24508 9.07666C4.79152 9.07666 4.42383 9.44435 4.42383 9.89792C4.42383 10.3515 4.79152 10.7192 5.24508 10.7192Z"
        fill="#113357"
      />
    </svg>
  );
};
